import { CommonTLFModule } from '../common/common.module';
import {
  DatiGenPraticaFormComponent
} from './components/wizard-creazione/components/step-dati-gen-pratica/components/dati-gen-pratica-form/dati-gen-pratica-form.component';
import {
  TipoPraticaWidgetComponent
} from './components/wizard-creazione/components/step-dati-gen-pratica/components/tipo-pratica-widget/tipo-pratica-widget.component';
import { CommonModule } from '@angular/common';
import {
  StepSoggettiTerziComponent
} from './components/wizard-creazione/components/step-soggetti-terzi/step-soggetti-terzi.component';
import { NgModule } from '@angular/core';
import {
  CreazionePraticaStepperComponent
} from './components/wizard-creazione/components/creazione-pratica-stepper/creazione-pratica-stepper.component';
import {
  ClassificazioniComponent
} from './components/wizard-creazione/components/step-dati-gen-pratica/components/classificazioni/classificazioni.component';
import {
  StepDatiGenPraticaComponent
} from './components/wizard-creazione/components/step-dati-gen-pratica/step-dati-gen-pratica.component';
import { ListPartiComponent } from './components/wizard-creazione/components/step-parti/list-parti/list-parti.component';
import {
  StepDatiGenFascicoloModule
} from './components/wizard-creazione/components/step-dati-gen-fascicolo/step-dati-gen-fascicolo.module';
import {
  AssociazioneControparteFormComponent
} from './components/wizard-creazione/components/step-parti/associazione-controparte-form/associazione-controparte-form.component';
import {
  StepDatiEconomiciComponent
} from './components/wizard-creazione/components/step-dati-economici/step-dati-economici.component';
import { StepAttiComponent } from './components/wizard-creazione/components/step-atti/step-atti.component';
import {
  ListContropartiComponent
} from './components/wizard-creazione/components/step-parti/list-controparti/list-controparti.component';
import {
  StepDatiGenFascicoloComponent
} from './components/wizard-creazione/components/step-dati-gen-fascicolo/step-dati-gen-fascicolo.component';
import { StepAttiFormComponent } from './components/wizard-creazione/components/step-atti/step-atti-form/step-atti-form.component';
import {
  ClassificazioneFormComponent
} from './components/wizard-creazione/components/step-dati-gen-pratica/components/classificazione-form/classificazione-form.component';
import {
  PetitumFormComponent
} from './components/wizard-creazione/components/step-dati-economici/components/petitum-form/petitum-form.component';
import { StepAdempimentiFormComponent } from './components/wizard-creazione/components/step-adempimenti/components/form/step-adempimenti-form.component';
import { StepAdempimentiListComponent } from './components/wizard-creazione/components/step-adempimenti/components/list/step-adempimenti-list.component';
import { StepSoggettiTerziListComponent } from './components/wizard-creazione/components/step-soggetti-terzi/components/soggetto-list/step-soggetti-terzi-list.component';
import { StepSoggettiTerziFormComponent } from './components/wizard-creazione/components/step-soggetti-terzi/components/form/step-soggetti-terzi-form.component';
import { StepPartiComponent } from './components/wizard-creazione/components/step-parti/step-parti.component';
import {
  AnagraficaParteFormComponent
} from './components/wizard-creazione/components/step-parti/anagrafica-parte-form/anagrafica-parte-form.component';
import {
  StepAdempimentiComponent
} from './components/wizard-creazione/components/step-adempimenti/step-adempimenti.component';
import {
  StepDocumentazioneAllegataComponent
} from './components/wizard-creazione/components/step-documentazione-allegata/step-documentazione-allegata.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepSoggettiTerziFormAssociativaComponent } from './components/wizard-creazione/components/step-soggetti-terzi/components/form/form-associativa/step-soggetti-terzi-form-associativa.component';
import { AddFolderFormComponent } from './components/wizard-creazione/components/step-documentazione-allegata/components/add-folder-form/add-folder-form.component';
import { NewDocumentFormComponent } from './components/wizard-creazione/components/step-documentazione-allegata/components/new-document-form/new-document-form.component';
import { StepSoggettiTerziListAltrepartiComponent } from './components/wizard-creazione/components/step-soggetti-terzi/components/step-soggetti-terzi-list-altreparti/step-soggetti-terzi-list-altreparti.component';
import { StepPartiFormInserimentoComponent } from './components/wizard-creazione/components/step-parti/step-parti-form-inserimento/step-parti-form-inserimento.component';
import { AttiListViewComponent } from './components/wizard-creazione/components/step-atti/atti-list-view/atti-list-view.component';


@NgModule({
  declarations: [
    CreazionePraticaStepperComponent,
    StepDatiGenPraticaComponent,
    ClassificazioneFormComponent,
    ClassificazioniComponent,
    DatiGenPraticaFormComponent,
    TipoPraticaWidgetComponent,
    StepPartiComponent,
    StepSoggettiTerziComponent,
    StepDatiEconomiciComponent,
    PetitumFormComponent,
    StepAttiComponent,
    StepAdempimentiFormComponent,
    StepAdempimentiListComponent,
    StepAdempimentiComponent,
    StepDocumentazioneAllegataComponent,
    StepAttiFormComponent,
    StepSoggettiTerziListComponent,
    StepSoggettiTerziFormComponent,
    ListPartiComponent,
    AnagraficaParteFormComponent,
    AssociazioneControparteFormComponent,
    ListContropartiComponent,
    AddFolderFormComponent,
    NewDocumentFormComponent,
    StepSoggettiTerziFormAssociativaComponent,
    StepSoggettiTerziListAltrepartiComponent,
    StepPartiFormInserimentoComponent,
    AttiListViewComponent,
  ],
  imports: [
    CommonModule,
    CommonTLFModule,
    ReactiveFormsModule,
    FormsModule,
    StepDatiGenFascicoloModule
  ],
  entryComponents: [
    StepAdempimentiComponent,
    StepAttiComponent,
    StepDatiEconomiciComponent,
    StepDatiGenPraticaComponent,
    StepDatiGenFascicoloComponent,
    StepDocumentazioneAllegataComponent,
    StepPartiComponent,
    StepSoggettiTerziComponent
  ]
})
export class PraticaModule { }
